import React from "react";
import { MultiSelect, MultiSelectProps } from "@mantine/core";

import styles from "@scss/custom-components/form-fields-dropdowns.module.scss";

interface CustomMultiSelectProps extends MultiSelectProps {
  wrap?: boolean; // Allow pills to wrap to multiple lines
}

export const CustomMultiSelect: React.FC<CustomMultiSelectProps> = ({
  variant = "default",
  classNames = {},
  wrap = false,
  ...props
}) => {
  const variantDropdownClasses: Record<string, string> = {
    default: styles["dropdown--default"],
    dark: styles["dropdown--dark"],
    darker: styles["dropdown--darker"],
    sky: styles["dropdown--sky"],
  };

  const customDropdownClass = variantDropdownClasses[variant] || "";

  return (
    <MultiSelect
      variant={variant}
      classNames={{
        ...classNames,
        dropdown: customDropdownClass,
        options: styles.options,
        option: styles.option,
        input: wrap ? styles.multiSelectInputWrap : (classNames as any).input,
      }}
      {...props}
    />
  );
};
